//-------------MONITORING_COPY--------------
import {Text, TextProps} from "evergreen-ui";
import {useSelector} from "react-redux";
import {stationsIdsLengthSelectorMonitoring} from "../../../App/Dictionaries/selectors";
import React from "react";
import {filteredStationsIdsLengthSelectorMonitoring} from "./selectorsMonitoring";

/** Сколько станций найдено из всех. Значения данных из слайсов. */
export function StationsFoundCountMonitoring(props: TextProps) {
    const filteredLength = useSelector(filteredStationsIdsLengthSelectorMonitoring);
    const allLength = useSelector(stationsIdsLengthSelectorMonitoring);

    return (
        <Text {...props}>{`Станции: ${filteredLength} из ${allLength}`}</Text>
    );
}
export const MemoStationsFoundCountMonitoring = React.memo(StationsFoundCountMonitoring);
MemoStationsFoundCountMonitoring.displayName = 'MemoStationsFoundCountMonitoring';
export default StationsFoundCountMonitoring;